import { useState, useEffect, useRef } from "react";
import Header from '../../components/header';
import Footer from '../../components/Footer';
import { Form, Button, Container, Row, Col, Modal, Spinner } from "react-bootstrap";
import './maintenance.css';
import axios from "axios";
import Loader from "../../components/Loader";
import { toast } from "react-hot-toast";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import MaskedTextInput from "react-text-mask";
import { debounce } from "lodash";
import { toArray } from "underscore";
import { IoMdInformationCircleOutline } from "react-icons/io";


const Maintenance = () => {
    const [data, setData] = useState([]);
    // console.log("data", data)
    const [getValue, setGetValue] = useState({
        factory: "",
        po: "",
        style: "",
        shipmentNo: "",
        startingdate: null,
        endingDate: null,
        shipmentDateStart: null,
        shipmentDateEnd: null
    })
    // console.log("getValue", getValue)
    const [disableInputTag, setDisableInputTag] = useState()
    const [loading, setLoading] = useState(false);
    const [loadingSinf, setLoadingSinf] = useState(false)
    // console.log("loadingSinf", loadingSinf)
    const [show, setShow] = useState(true);
    const [checkedValue, setCheckedValue] = useState()
    // console.log("checkedValue",checkedValue)
    const [checkedTableValue, setCheckedTableValue] = useState([]);
    // console.log("checkedTableValue", checkedTableValue.length)
    const [checkValueCheckBox, setCheckValueCheckBox] = useState(false)
    const [showInfo, setShowInfo] = useState(null)
    const [sinfData, setSinfData] = useState([]);
    // console.log("checking>>>>", sinfData)
    const popupRef = useRef(null);
    const [pageNo, setPageNo] = useState(0);
    const [hasMoreData, setHasMoreData] = useState(true);
    const loaderRef = useRef(null);
    const item_per_page = 30;
    const [emojiOperator, setEmojiOperator] = useState({
        FACT: "⬆",
        SUP: "⬆",
        AGNT: "⬆",
        PO: "⬆",
        STY: "⬆",
        ETD: "⬆",
        poDate: "⬆",
        transferDate: "⬆"
    });
    const [initialFetchDone, setInitialFetchDone] = useState(false);


    const sortRef = useRef({ name: "", order: "" });
    const emojiOperatorChange = (e) => {
        const name = e.target.dataset.name;
        const order = emojiOperator[name] === "⬆" ? "DESC" : "ASC";

        // Update refs
        sortRef.current = { name, order };

        const validNames = ["STY", "PO", "FACT", "SUP", "AGNT", "ETD", "poDate", "transferDate"];

        if (validNames.includes(name)) {
            setEmojiOperator((prev) => ({
                ...prev,
                [name]: prev[name] === "⬆" ? "⬇" : "⬆",
            }));
        }

        // Clear and fetch with new sorting
        setData([]);
        setHasMoreData(true);
        // skipNextPageFetch.current = true;
        setCheckedTableValue([]);
        if (pageNo > 0) {
            setPageNo(0);
        }
        else {
            fetchData({
                ...getValue,
                closed: checkValueCheckBox,
                dataSetName: name,
                inColumnName: order,
            });
        }

    };

    // useEffect(() => {
    //     if(!initialFetchDone) return;
    //     debouncedFetch({
    //         ...getValue,
    //         closed: checkValueCheckBox,
    //         dataSetName: sortRef.current.name,
    //         inColumnName: sortRef.current.order,
    //     });
    // }, [getValue]);

    let controller = null; // Declare globally or at least at component level

    const fetchData = async (values) => {
        if (controller) {
            controller.abort();
        }

        controller = new AbortController(); // Create new controller for this request
        setLoading(true);
        setDisableInputTag(0);


        try {
            const token = localStorage.getItem("token");

            const formatDate = (date) => {
                if (!date) return null;
                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const day = String(d.getDate()).padStart(2, "0");
                return `${year}${month}${day}`;
            };

            const formattedStartingDate = formatDate(values.startingdate);
            const formattedEndingDate = formatDate(values.endingDate);

            // const formatted = "20210806".replace(/(\d{4})(\d{2})(\d{2})/, "$3/$2/$1");

            const response = await axios.get(
                `${process.env.REACT_APP_API_LINK}/api/v1/po/getAdminMaintenance`,
                {
                    params: {
                        closed: values.closed,
                        startETD: formattedStartingDate,
                        endETD: formattedEndingDate,
                        fromShipTime: values.shipmentDateStart || null,
                        toShipTime: values.shipmentDateEnd || null,
                        PO: values.po || "",
                        STY: values.style || "",
                        FACT: values.factory || "",
                        shipGroup: values.shipmentNo || "",
                        docNo: item_per_page,
                        pageNo: pageNo,
                        colForSorting: values.dataSetName,
                        inOrder: values.inColumnName,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    signal: controller.signal,
                }
            );
            const newData = Array.isArray(response.data.data) ? response.data.data : [];
            // const newData= response.data.data?response.data.data:[]
            // setData((prev) => [...prev, ...newData]);
            setData((prev) => pageNo === 0 ? newData : [...prev, ...newData]);

            if (newData.length < 30) {
                setHasMoreData(false);
            }
            else {
                setHasMoreData(true)
            }
        } catch (error) {
            if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
                console.log("Request canceled");
            } else {
                console.error("Error fetching data:", error);
                setData([]);
            }
        } finally {
            setLoading(false);
            setDisableInputTag(1)
        }
    };


    useEffect(() => {
        if (loading || !hasMoreData) return;
        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    setPageNo(prevPage => prevPage + 1);
                }
            },
            {
                threshold: 0.1,
                rootMargin: '100px', // preload when loader is close to view
            }
        );

        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, [loading, hasMoreData]);

    useEffect(() => {
        if (skipNextPageFetch.current) {
            skipNextPageFetch.current = false;
            return; // Skip duplicate call
        }
        fetchData({
            ...getValue,
            closed: checkValueCheckBox,
            dataSetName: sortRef.current.name,
            inColumnName: sortRef.current.order,
        }); // Fetch for pagination
        setInitialFetchDone(true);
    }, [pageNo]);


    // debounce function
    const skipNextPageFetch = useRef(false);

    const debouncedFetch = useRef(
        debounce(async (val) => {
            setData([]); // Reset previous data
            setHasMoreData(true); // Reset scroll flag
            setPageNo(0); // This will trigger useEffect, we’ll handle that
            // setCheckedTableValue([]);
            await fetchData(val); // Perform the actual fetch
        }, 2000)
    ).current;

    // Function to toggle "Select All"

    const handleSelectAll = (event) => {
        const checked = event.target.checked;
        setCheckedValue(checked);

        // Update all checkboxes and checkedTableValue
        const updatedData = data.map((item) => ({ ...item, isChecked: checked }));
        setData(updatedData);

        setCheckedTableValue(checked ? updatedData.map((item) => item.PO) : []);
    };

    // Handle Individual Checkbox Selection
    const handleCheckboxChange = (e, PO) => {
        const checked = e.target.checked;

        setData(prevData =>
            prevData.map(item =>
                item.PO === PO ? { ...item, isChecked: checked } : item
            )
        );

        setCheckedTableValue(prevState =>
            checked ? [...prevState, PO] : prevState.filter(item => item !== PO)
        );
    }

    const showData = () => {
        setShow(!show);
    }
    // Handle input changes
    const getInputValue = (e) => {
        const { name, value } = e.target;
        // console.log("name",name,"value",value)
        const upperValue = value.toUpperCase();

        // Build the updated value manually
        const updatedValue = {
            ...getValue,
            [name]: upperValue,
        };

        setGetValue(updatedValue);
        setCheckedTableValue([]);
        debouncedFetch({
            ...updatedValue,
            closed: checkValueCheckBox,
            dataSetName: sortRef.current.name,
            inColumnName: sortRef.current.order,
        });
    };

    const getResetValue = () => {
        // Reset filters
        const resetValues = {
            factory: "",
            po: "",
            style: "",
            startingdate: "",
            endingDate: "",
            shipmentNo: "",
        };

        setGetValue(resetValues);
        setCheckedTableValue([]);
        setData([]);  // Clear previous data
        setHasMoreData(true);
        setCheckValueCheckBox(false);

        // Reset all checkboxes in data (uncheck)
        setData(prevData => prevData.map(item => ({ ...item, isChecked: false })));

        if (pageNo > 0) {
            setPageNo(0);
        }
        else {
            fetchData(resetValues);
        }
    };



    // Delete api function
    const getDeleteEntry = async () => {
        if (checkedTableValue.length > 200) {
            toast.remove();
            return toast.error("Cannot delete or purge more than 200 POs.");
        }
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33", // Red color for delete
            cancelButtonColor: "#3085d6", // Default blue color
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                try {
                    const token = localStorage.getItem("token");
                    await axios.post(
                        `${process.env.REACT_APP_API_LINK}/api/v1/admin/resetMultiplePOs`,
                        { pos: checkedTableValue },
                        {
                            headers: { Authorization: `Bearer ${token}` },
                        }
                    );
                    Swal.fire({
                        title: "Deleted!",
                        text: "Your entries have been deleted successfully.",
                        icon: "success",
                        confirmButtonColor: "#28a745", // Green color for OK button
                        confirmButtonText: "OK"
                    }).then(async () => {
                        setPageNo(0);
                        setData([]);
                        setHasMoreData(true);
                        await fetchData({
                            ...getValue,
                            closed: checkValueCheckBox,
                            dataSetName: sortRef.current.name,
                            inColumnName: sortRef.current.order,
                        }); // Fetch updated data after deletion
                    });

                    setCheckedTableValue([]); //  Clear selected table values

                } catch (error) {
                    console.error("Error deleting entry:", error);
                    toast.error("Failed to delete entries!");
                } finally {
                    // setLoading(false);
                }
            }
        });
    };


    const getClosePO = async () => {
        const selectedData = data.filter((d) => checkedTableValue.includes(d.PO));
        const notNullDataForShipment = selectedData.filter((d) => {
            // const isNull = d.shipGroup.every(s => s.length > 0);
            const isNull = d.shipGroup.length === 0;
            console.log('inside notnull', isNull)
            return !isNull;
        })
        const notNullPOs = new Set(notNullDataForShipment.map(d => d.PO));

        const remainingPOs = selectedData
            .filter(d => !notNullPOs.has(d.PO))
            .map(d => d.PO);
        let displayPOs = "";

        if (remainingPOs.length > 3) {
            displayPOs = `${remainingPOs.slice(0, 3).join(", ")} and more`;
        } else {
            displayPOs = remainingPOs.join(", ");
        }

        const ifReadyToClose = notNullDataForShipment.length === selectedData.length ? true : false;
        if (ifReadyToClose === false) {
            toast.remove();
            return toast.error(`POs(${displayPOs}) cannot be closed as shipment is not available.`);
        }

        Swal.fire({
            title: "Do you want to close this Entry?",
            showCancelButton: true,
            confirmButtonText: "Yes, close it!",
            cancelButtonText: "No",
            icon: "warning",
            customClass: {
                confirmButton: "swal-confirm-btn", // Green "Yes" button
                cancelButton: "swal-cancel-btn"   // Red "No" button
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setLoading(true);
                    const token = localStorage.getItem("token");

                    await axios.post(
                        `${process.env.REACT_APP_API_LINK}/api/v1/po/multiClosePO`,
                        { pos: checkedTableValue },
                        {
                            headers: { Authorization: `Bearer ${token}` },
                        }
                    );

                    // toast.success("Entries closed successfully!");

                    //  Show success alert with green OK button
                    Swal.fire({
                        title: "Closed!",
                        text: "The entry has been closed.",
                        icon: "success",
                        confirmButtonText: "OK",
                        customClass: {
                            confirmButton: "swal-ok-btn"  // Custom class for green OK button
                        }
                    }).then(async () => {
                        setPageNo(0);
                        setData([]);
                        setHasMoreData(true);
                        await fetchData({
                            ...getValue,
                            closed: checkValueCheckBox,
                            dataSetName: sortRef.current.name,
                            inColumnName: sortRef.current.order,
                        }); //  Fetch updated data after ClosePO
                    });
                    setCheckedTableValue([]); //  Clear selected table values

                } catch (error) {
                    console.error("Error closing PO:", error);
                    toast.error("Failed to close the entry.");
                } finally {
                    // setLoading(false);
                }
            }
        });
    };

    const getOpenPO = async () => {
        Swal.fire({
            title: "Do you want to open this Entry?",
            showCancelButton: true,
            confirmButtonText: "Yes, open it!",
            cancelButtonText: "No",
            icon: "warning",
            customClass: {
                confirmButton: "swal-confirm-btn", // Green "Yes" button
                cancelButton: "swal-cancel-btn"   // Red "No" button
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setLoading(true);
                    const token = localStorage.getItem("token");

                    await axios.post(
                        `${process.env.REACT_APP_API_LINK}/api/v1/po/multiOpenPO`,
                        { pos: checkedTableValue },
                        {
                            headers: { Authorization: `Bearer ${token}` },
                        }
                    );

                    // toast.success("Entries closed successfully!");

                    //  Show success alert with green OK button
                    Swal.fire({
                        title: "Opened!",
                        text: "The entry has been Opened.",
                        icon: "success",
                        confirmButtonText: "OK",
                        customClass: {
                            confirmButton: "swal-ok-btn"  // Custom class for green OK button
                        }
                    }).then(async () => {
                        setPageNo(0);
                        setData([]);
                        setHasMoreData(true);
                        await fetchData({
                            ...getValue,
                            closed: checkValueCheckBox,
                            dataSetName: sortRef.current.name,
                            inColumnName: sortRef.current.order,
                        });  //  Fetch updated data after ClosePO
                    });
                    setCheckedTableValue([]); //  Clear selected table values

                } catch (error) {
                    console.error("Error Opening PO:", error);
                    toast.error("Failed to open the entry.");
                } finally {
                    // setLoading(false);
                }
            }
        });
    }


    const getvalueCheckBox = (e) => {
        const checked = e.target.checked;
        setData([])
        setCheckValueCheckBox(checked);

        const updatedFilters = {
            ...getValue, // your existing filters like PO, style, etc.
            closed: checked, // pass updated checkbox value
            dataSetName: sortRef.current.name,
            inColumnName: sortRef.current.order,
        };
        setCheckedTableValue([]);
        setHasMoreData(true);
        setPageNo(0);

        fetchData(updatedFilters);
    };

    const getStartingDate = (date) => {
        setGetValue((prev) => {
            const updatedFilters = { ...prev, startingdate: date ?? null };
            // debouncedFetch(updatedFilters); 
            setCheckedTableValue([]);
            debouncedFetch({
                ...updatedFilters,
                closed: checkValueCheckBox,
                dataSetName: sortRef.current.name,
                inColumnName: sortRef.current.order,
            });
            return updatedFilters;
        });
    };

    const getEndingDate = (date) => {
        setGetValue((prev) => {
            const updatedFilters = { ...prev, endingDate: date ?? null };
            // debouncedFetch(updatedFilters); // Call debounced function here
            setCheckedTableValue([]);
            debouncedFetch({
                ...updatedFilters,
                closed: checkValueCheckBox,
                dataSetName: sortRef.current.name,
                inColumnName: sortRef.current.order,
            });
            return updatedFilters;
        });
    };


    const getShipmentDateStart = (date) => {

        if (!date) {
            const updatedFilters = {
                ...getValue,
                shipmentDateStart: "",
            };
            setGetValue(updatedFilters);
            // debouncedFetch(updatedFilters);
            setCheckedTableValue([]);
            debouncedFetch({
                ...updatedFilters,
                closed: checkValueCheckBox,
                dataSetName: sortRef.current.name,
                inColumnName: sortRef.current.order,
            });
            return;
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`; // "YYYY-MM-DD"

        const updatedFilters = {
            ...getValue,
            shipmentDateStart: formattedDate,
        };
        setGetValue(updatedFilters);
        // debouncedFetch(updatedFilters); 
        setCheckedTableValue([]);
        debouncedFetch({
            ...updatedFilters,
            closed: checkValueCheckBox,
            dataSetName: sortRef.current.name,
            inColumnName: sortRef.current.order,
        });
    };


    const getShipmentDateEnd = (date) => {

        if (!date) {
            const updatedFilters = {
                ...getValue,
                shipmentDateEnd: "",
            };
            setGetValue(updatedFilters);
            // debouncedFetch(updatedFilters);
            setCheckedTableValue([]);
            debouncedFetch({
                ...updatedFilters,
                closed: checkValueCheckBox,
                dataSetName: sortRef.current.name,
                inColumnName: sortRef.current.order,
            });
            return;
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`; // "YYYY-MM-DD"

        const updatedFilters = {
            ...getValue,
            shipmentDateEnd: formattedDate,
        };
        setGetValue(updatedFilters);
        // debouncedFetch(updatedFilters); 
        setCheckedTableValue([]);
        debouncedFetch({
            ...updatedFilters,
            closed: checkValueCheckBox,
            dataSetName: sortRef.current.name,
            inColumnName: sortRef.current.order,
        });
    };


    const showInfoData = async (index, PO) => {
        // console.log(PO)
        // Toggle popup
        if (showInfo === index) {
            setShowInfo(null);
            setSinfData([]);
            return;
        }

        setShowInfo(index);
        setLoadingSinf(true); // Start loader BEFORE API call

        const api = `${process.env.REACT_APP_API_LINK}/api/v1/po/getUserEanByPO?PO=${PO}`;
        const token = localStorage.getItem("token");

        try {
            const response = await axios.get(api, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (Array.isArray(response.data.SINF)) {
                setSinfData(response.data.SINF);
            } else {
                setSinfData([]);
            }
        } catch (error) {
            console.error("Error fetching PO data:", error);
            setSinfData([]);
        } finally {
            setLoadingSinf(false); // Stop loader after API call
        }
    };



    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setSinfData([]);
            setShowInfo(null);

        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);





    return (
        <>
            <div className="sticky-top">
                <div><Header /></div>
                <div style={{ width: "99.7%" }}>
                    <Container fluid  >
                        <Row
                            id="maintenance_main_1"
                            style={{
                                width: "102%",
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "centers",
                            }}
                        >
                            <Col lg={2} id="maintenace_col">
                                <div className="form-group">
                                    <Form.Label className="fs-6" id="input_lable_maintance_">Factory</Form.Label>
                                    <Form.Control
                                        id="factory_input"
                                        type="text"
                                        name="factory"
                                        value={getValue.factory}
                                        // disabled={disableInputTag === 0}
                                        style={{ width: "110px" }}
                                        placeholder="Factory"
                                        maxLength={5}
                                        autoComplete="off"
                                        onChange={(e) => {
                                            let value = e.target.value.toUpperCase();
                                            if (/^[A-Z]*$/.test(value)) {  // Allows only alphabetic values
                                                getInputValue(e);
                                            }
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col lg={2} id="maintenace_col">
                                <div className="form-group">
                                    <Form.Label className="fs-6" id="input_lable_maintance_">PO#</Form.Label>
                                    <Form.Control
                                        id="factory_input"
                                        type="text"
                                        name="po"
                                        value={getValue.po}
                                        // disabled={disableInputTag === 0}
                                        style={{ width: "110px" }}
                                        placeholder="PO"
                                        maxLength={6}
                                        autoComplete="off"
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value)) {  // Allows only numeric values
                                                getInputValue(e); // Update the state
                                            }
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col lg={2} id="maintenace_col">
                                <div className="form-group">
                                    <Form.Label className="fs-6" id="input_lable_maintance_">Style</Form.Label>
                                    <Form.Control
                                        id="factory_input"
                                        type="text"
                                        name="style"
                                        value={getValue.style}
                                        // disabled={disableInputTag === 0}
                                        style={{ width: "110px" }}
                                        placeholder="Style"
                                        maxLength={8}
                                        autoComplete="off"
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[a-zA-Z0-9]*$/.test(value)) {  // Allows only alphabets (A-Z, a-z) and numbers (0-9)
                                                getInputValue(e);
                                            }
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col lg={2} id="maintenace_col_1">
                                <div className="form-group" id="date_input_main">
                                    <Form.Label className="fs-6" id="input_lable_maintance">ETD From:</Form.Label>
                                    <DatePicker
                                        id="date_input"
                                        className="form-control border border-dark my-1 "
                                        selected={getValue.startingdate || null}  // ✅ 
                                        onChange={getStartingDate} // ✅
                                        isClearable
                                        title="Enter date to Filter the table"
                                        name="startingDate"
                                        dateFormat="dd/MM/yyyy" // ✅ Ensures the correct format in the DatePicker
                                        // disabled={isApiLoading ? "disable" : null}
                                        placeholderText="Start Date"
                                        showMonthDropdown
                                        showYearDropdown
                                        showPopperArrow
                                        customInput={
                                            <MaskedTextInput
                                                type="text"
                                                mask={[
                                                    /\d/,
                                                    /\d/,
                                                    "/",
                                                    /\d/,
                                                    /\d/,
                                                    "/",
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                ]}
                                            />
                                        }
                                        autoComplete="off"
                                    />
                                </div>
                            </Col>
                            <Col lg={2} id="maintenace_col_1">
                                <div className="form-group" id="date_input_main">
                                    <Form.Label className="fs-6" id="input_lable_maintance"> ETD To:</Form.Label>
                                    <DatePicker
                                        id="date_input"
                                        className="form-control border border-dark my-1 "
                                        selected={getValue.endingDate || null}
                                        onChange={getEndingDate}
                                        // disabled={disableInputTag === 0}
                                        title="Enter date to Filter the table"
                                        name="startingDate"
                                        dateFormat="dd/MM/yyyy" // ✅ Ensures the correct format in the DatePicker
                                        isClearable
                                        // disabled={isApiLoading ? "disable" : null}
                                        placeholderText="End Date"
                                        showMonthDropdown
                                        showYearDropdown
                                        showPopperArrow
                                        customInput={
                                            <MaskedTextInput
                                                type="text"
                                                mask={[
                                                    /\d/,
                                                    /\d/,
                                                    "/",
                                                    /\d/,
                                                    /\d/,
                                                    "/",
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                ]}
                                            />
                                        }
                                        autoComplete="off"
                                    />
                                </div>
                            </Col>
                            <Col lg={2} id="maintenace_col_1">
                                <div className="form-group" id="date_input_main">
                                    <Form.Label className="fs-6" id="input_lable_maintance_1">Transfer From:</Form.Label>
                                    <DatePicker
                                        id="date_input"
                                        className="form-control border border-dark my-1 "
                                        selected={getValue.shipmentDateStart || null}
                                        onChange={getShipmentDateStart}
                                        // disabled={disableInputTag === 0}
                                        title="Enter date to Filter the table"
                                        name="shipmentDateStart"
                                        dateFormat="dd/MM/yyyy" // ✅ Ensures the correct format in the DatePicker
                                        isClearable
                                        placeholderText="Start Date"
                                        showMonthDropdown
                                        showYearDropdown
                                        showPopperArrow
                                        customInput={
                                            <MaskedTextInput
                                                type="text"
                                                mask={[
                                                    /\d/,
                                                    /\d/,
                                                    "/",
                                                    /\d/,
                                                    /\d/,
                                                    "/",
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                ]}
                                            />
                                        }
                                        autoComplete="off"
                                    />
                                </div>
                            </Col>
                            <Col lg={2} id="maintenace_col_1">
                                <div className="form-group" id="date_input_main">
                                    <Form.Label className="fs-6" id="input_lable_maintance_1">Transfer To:</Form.Label>
                                    <DatePicker
                                        id="date_input"
                                        className="form-control border border-dark my-1 "
                                        selected={getValue.shipmentDateEnd || null}
                                        onChange={getShipmentDateEnd}
                                        isClearable
                                        title="Enter date to Filter the table"
                                        name="shipmentDateStart"
                                        dateFormat="dd/MM/yyyy" // ✅ Ensures the correct format in the DatePicker
                                        // disabled={isApiLoading ? "disable" : null}
                                        placeholderText="End Date"
                                        showMonthDropdown
                                        showYearDropdown
                                        showPopperArrow
                                        customInput={
                                            <MaskedTextInput
                                                type="text"
                                                mask={[
                                                    /\d/,
                                                    /\d/,
                                                    "/",
                                                    /\d/,
                                                    /\d/,
                                                    "/",
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                ]}
                                            />
                                        }
                                        autoComplete="off"
                                    />
                                </div>
                            </Col>

                            <Col lg={2} id="maintenace_col_1">
                                <div className="form-group">
                                    <Form.Label className="fs-6" id="input_lable_maintance_">Shipment No.</Form.Label>
                                    <Form.Control
                                        id="factory_input"
                                        // type="text"
                                        name="shipmentNo"
                                        value={getValue.shipmentNo}
                                        // disabled={disableInputTag === 0}
                                        style={{ width: "110px" }}
                                        placeholder="Shipment No."
                                        // maxLength={8}
                                        autoComplete="off"
                                        onChange={(e) => {
                                            getInputValue(e);
                                        }}
                                    />
                                </div>
                            </Col>

                            <Col lg={3} style={{ padding: "0" }} id="btn_both_maintenace">
                                {/* <div id="maintenance_btn">
                                <Button variant="primary" className="me-2">
                                    {"Filter"}
                                </Button>
                            </div> */}
                                <div id="maintenance_btn">
                                    <Button variant="danger" className="me-2"
                                        onClick={getResetValue}
                                    // disabled={disableInputTag === 0}
                                    >
                                        {"Reset"}
                                    </Button>
                                </div>
                                <div id="maintenance_btn">
                                    <Button variant="success" className="me-2" onClick={getDeleteEntry}
                                        disabled={checkedTableValue.length === 0}
                                    >
                                        {"Purge"}
                                    </Button>
                                </div>
                                {!checkValueCheckBox ? (<div id="maintenance_btn">
                                    <Button variant="primary" className="me-2" id="muti_btn" onClick={getClosePO}
                                        style={{ width: "fit-content" }}
                                        disabled={checkedTableValue.length === 0}
                                    >
                                        {"Close PO"}
                                    </Button>
                                </div>) :
                                    (<div id="maintenance_btn">
                                        <Button variant="primary" className="me-2" id="muti_btn" onClick={getOpenPO}
                                            style={{ width: "fit-content" }}
                                            disabled={checkedTableValue.length === 0}
                                        >
                                            {"Open PO"}
                                        </Button>
                                    </div>)}
                            </Col>
                            <Col lg={1} id="maintenace_col_checkBox">
                                <div id="closePO_main">
                                    <input
                                        type="checkbox"
                                        id="checked_input"
                                        checked={checkValueCheckBox} //  Controlled checkbox
                                        // onChange={(e) => setCheckValueCheckBox(e.target.checked)} //  Proper event handler
                                        onChange={getvalueCheckBox}
                                    />
                                    Close PO
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            <div className='maintenance_main'>


                {/* Table */}
                <div className="table-responsive tableFixHead table-container" id="maintenance_table">
                    <div id="maintenance_table1">
                        <table className="table table-bordered table-hover table-sm table-header-for-all">
                            <thead>
                                <tr className="table-warning">
                                    <th>
                                        <div>Select</div>
                                        <div>
                                            <input
                                                type="checkbox"
                                                id="input_checkout_map"
                                                value={checkedValue}
                                                onChange={handleSelectAll}
                                                checked={data.length > 0 && data.every((item) => item.isChecked)}
                                            // style={{ border: "2px solid green" }} 
                                            />

                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        data-name="STY"

                                    >Style
                                        <div id="emoji_main">
                                            <div data-name="STY" id="emoji" onClick={emojiOperatorChange}>{emojiOperator.STY}</div>
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        data-name="PO"
                                    >
                                        <div id="">PO#</div>
                                        <div id="emoji_main">
                                            <div data-name="PO" id="emoji" onClick={emojiOperatorChange} >{emojiOperator.PO}</div>
                                        </div>
                                    </th>

                                    <th
                                        scope="col"
                                        data-name="FACT"
                                    >
                                        <div id="">Factory</div>
                                        <div id="emoji_main">
                                            <div data-name="FACT" id="emoji" onClick={emojiOperatorChange}>{emojiOperator.FACT}</div>
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        data-name="SUP"

                                    >
                                        <div id="">Supplier</div>
                                        <div id="emoji_main">
                                            <div data-name="SUP" id="emoji" onClick={emojiOperatorChange}>{emojiOperator.SUP}</div>
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        data-name="agent"
                                    >
                                        <div id="">Agent</div>
                                        <div id="emoji_main">
                                            <div data-name="AGNT" id="emoji" onClick={emojiOperatorChange}>{emojiOperator.AGNT}</div>
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        data-name="fcus"
                                    // onClick={emojiOperatorChange}
                                    >
                                        <div id="">For_Cust</div>
                                        <div id="emoji_main">
                                            <div data-name="tot_qty" id="emoji" style={{ backgroundColor: "#fff3cd", color: "#fff3cd" }}>.</div>
                                        </div>
                                    </th>


                                    {/* <th><div id="">Supplier</div></th> */}

                                    <th
                                        scope="col"
                                        data-name="tot_qty"
                                    // onClick={emojiOperatorChange}
                                    >
                                        <div id="">Tot_Qty</div>
                                        <div id="emoji_main">
                                            <div data-name="tot_qty" id="emoji" style={{ backgroundColor: "#fff3cd", color: "#fff3cd" }}>.</div>
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        data-name="tot_packed"
                                    // onClick={emojiOperatorChange}
                                    >
                                        <div id="">Tot_Packed</div>
                                        <div id="emoji_main">
                                            <div data-name="tot_qty" id="emoji" style={{ backgroundColor: "#fff3cd", color: "#fff3cd" }}>.</div>
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        data-name="tot_balance"
                                    // onClick={emojiOperatorChange}
                                    >
                                        <div id="">Tot_Balance</div>
                                        <div id="emoji_main">
                                            <div data-name="tot_qty" id="emoji" style={{ backgroundColor: "#fff3cd", color: "#fff3cd" }}>.</div>
                                        </div>
                                    </th>
                                    <th>
                                        <div>
                                            <div id="">Tot_Transfer_Data</div>
                                            <div id="refresh_btn">
                                                <div id="data">{show ? "Box" : "Qty"} </div>
                                                <div onClick={showData} style={{ cursor: "pointer" }}>
                                                    🔃
                                                </div>
                                            </div>
                                        </div>
                                    </th>
                                    <th>
                                        <div id="">Shipment No.</div>
                                        <div id="emoji_main">
                                            <div data-name="tot_qty" id="emoji" style={{ backgroundColor: "#fff3cd", color: "#fff3cd" }}>.</div>
                                        </div>
                                    </th>
                                    {/* <th><div id="">Closed</div></th> */}
                                    <th
                                        scope="col"
                                        data-name="ETD"
                                    // onClick={emojiOperatorChange}
                                    >
                                        <div id="">ETD</div>
                                        <div id="emoji_main">
                                            <div data-name="ETD" id="emoji" onClick={emojiOperatorChange} >{emojiOperator.ETD}</div>
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        data-name="poDate"
                                    >
                                        <div id="">PO Date</div>
                                        <div id="emoji_main">
                                            <div data-name="poDate" id="emoji" onClick={emojiOperatorChange}>{emojiOperator.poDate}</div>
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        data-name="transferDate"
                                    // onClick={emojiOperatorChange}
                                    >
                                        <div id="">Transfer Date</div>
                                        <div id="emoji_main">
                                            <div data-name="transferDate" id="emoji" onClick={emojiOperatorChange}>{emojiOperator.transferDate}</div>
                                        </div>
                                    </th>
                                    {checkValueCheckBox === true ? <th>
                                        <div id="">Closed Date</div>
                                        <div id="emoji_main">
                                            <div data-name="tot_qty" id="emoji" style={{ backgroundColor: "#fff3cd", color: "#fff3cd" }}>.</div>
                                        </div>
                                    </th> : null}
                                </tr>
                            </thead>
                            <tbody style={{ fontWeight: "400" }}>
                                {/* Show "No Data Available" if data is empty */}
                                {loading && (
                                    <tr>
                                        <td colSpan="16" style={{ textAlign: "center", fontWeight: "400" }} ref={loaderRef}>
                                            <div>
                                                <Loader />
                                            </div>
                                        </td>
                                    </tr>
                                )}

                                {/* Show data rows if data is available */}
                                {data && data.length > 0 && (
                                    data.map((item, index) => (
                                        <tr key={index}>
                                            {/* {console.log("item",item)} */}
                                            <td>
                                                {index + 1}
                                                <input
                                                    type="checkbox"
                                                    id="table_input_checkbox"
                                                    checked={item.isChecked}
                                                    onChange={(e) => handleCheckboxChange(e, item.PO)}
                                                />
                                            </td>
                                            <td>{item.STY}</td>
                                            <td>
                                                <div className="maintenance_po">
                                                    <div className="maintenance_po_1">{item.PO}</div>
                                                    <div className="maintenance_po_2" onClick={() => showInfoData(index, item.PO)}>
                                                        <IoMdInformationCircleOutline />
                                                    </div>

                                                    {/* Popup logic */}
                                                    {showInfo === index && (
                                                        <div className={`${sinfData.length > 4 ? "infoMain" : "infoMain2"}`} ref={popupRef}>
                                                            {loadingSinf ? (
                                                                <p className="loading_Sinf">
                                                                    <Spinner animation="border" size="sm" />
                                                                </p>
                                                            )
                                                                : sinfData.length > 0 ? (
                                                                    // <div>
                                                                    <div className={`${sinfData.length > 4 ? "popupMain" : "popupMain2"}`}>
                                                                        {sinfData.map((sinf, idx) => (
                                                                            <div key={idx} className="sinf_text">
                                                                                <div id={`${sinfData.length > 4 ? "sinfText" : "sinfText_length1"}`}>EAN</div>
                                                                                <div id={`${sinfData.length > 4 ? "sinfText_1" : "sinfText_1_length1"}`}>:-</div>
                                                                                <div id={`${sinfData.length > 4 ? "sinfText_2" : "sinfText_2_length1"}`}>{sinf}</div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                    // </div>
                                                                )
                                                                    : (
                                                                        <p className="notAssign2">Not assigned..</p>
                                                                    )}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>

                                            <td>{item.FACT}</td>
                                            <td>{item.SUP}</td>
                                            <td>{item.AGNT}</td>
                                            <td>{item.FCUS}</td>
                                            <td>{item.totalQuantity}</td>
                                            <td>{item.totalPacked}</td>
                                            <td>{item.totalBalance}</td>
                                            <td>{show ? item.totalTranferDataBox : item.totalTranferDataQTy}</td>
                                            <td>{item.shipGroup.length > 1 ? (item.shipGroup[1] + "*") || "" : item.shipGroup[0] || ""}</td>
                                            {/* <td>{item.etd ? `${item.etd.slice(6, 8)}/${item.etd.slice(4, 6)}/${item.etd.slice(0, 4)}` : ""}</td> */}
                                            <td>{item.ETD ? item.ETD.replace(/(\d{4})(\d{2})(\d{2})/, '$3/$2/$1') : ''}</td>
                                            <td>{item.poDate ? new Date(item.poDate).toLocaleDateString('en-GB') : ""}</td>
                                            <td>
                                                <div className="ShipTime_main">
                                                    <div className="ShipTime_main_1">
                                                        {/* <div className="ShipTime_main_inside">Date:-</div> */}
                                                        <div className="ShipTime_main_inside_1">{item.transferDate ? new Date(item.transferDate).toLocaleDateString('en-GB') : ""}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            {checkValueCheckBox === true && (
                                                <td>{item.closedDate ? new Date(item.closedDate).toLocaleDateString('en-GB') : ""}</td>
                                            )}
                                        </tr>
                                    ))
                                )}

                                {/* Show "No Data Available" again if data is empty */}
                                {!loading && data && data.length === 0 && (
                                    <tr>
                                        <td colSpan="16" style={{ textAlign: "center" }}>No Data Available</td>
                                    </tr>
                                )}

                                {/* Loader at the bottom while fetching more */}
                                {data.length > 0 && hasMoreData && (
                                    // <tfoot>
                                    <tr className="border-0">
                                        <td
                                            colSpan={100}
                                            style={{
                                                border: "none",
                                                textAlign: "center",
                                                backgroundColor: "transparent",
                                            }}
                                        >
                                            <div
                                                ref={loaderRef}
                                                className="d-flex justify-content-center align-items-center w-100"
                                            >
                                                <div className="spinner-border" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    // </tfoot>

                                )}
                            </tbody>




                        </table>
                    </div>
                </div>
            </div>
            <div><Footer /></div>
        </>
    )
}

export default Maintenance